<template>
    <div>
        <hgroup v-if="property.headline || property.summary">
            <h5 class="display-5 mb-4" v-if="property.headline">{{ property.headline }}</h5>
            <h6 class="display-5 mb-4" v-if="property.summary">{{ property.summary }}</h6>
        </hgroup>
        <html-content v-if="shortDescription" :html="shortDescription" class="text-muted" />
        <p v-if="hasMoreDescription">
            <a href="#" @click.prevent="openFullDescription">Learn more</a>
        </p>
        <p v-else>
            {{ rentalRegistration }}
        </p>

        <modal v-if="showDescriptionModal" size="lg" :open="descriptionModalOpen" @close="closeFullDescription">
            <template #header>
                {{ property.name }}
            </template>
            <template #default>
                <html-content :html="propertyDescription"/>
                <p>
                    {{ rentalRegistration }}
                </p>
            </template>
            <template #buttons>
                <ui-button color="secondary" @click="descriptionModalOpen=false" :underline="true" block="sm">
                    Close
                </ui-button>
            </template>
        </modal>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import HtmlContent from '@/components/Content/HtmlContent.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            HtmlContent,
            ...CommonComponents,
        },

        data() {
            return {
                hasMoreDescription: false,
                showDescriptionModal: false,
                descriptionModalOpen: true,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {

            propertyDescription() {
                if (this.property) {
                    if (this.property.dynamicDescription) {
                        return this.property.introDescription
                    }
                    else {
                        return this.property.description;
                    }
                }

                return null;
            },

            shortDescription() {
                this.setHasMoreDescription(false);

                if (this.property) {
                    let limit = 500;

                    let fullHtml = this.propertyDescription || (this.property.name || '');

                    let arr = fullHtml.split('</p>');
                    let html = [];
                    let len = 0;
                    for (let i=0; i<arr.length; i++) {
                        html.push(arr[i]);
                        len += arr[i].length;
                        
                        if (len > limit) {
                            if (i < arr.length - 1) {
                                this.setHasMoreDescription(true);
                            }
                            break;
                        }
                    }

                    if (html.length) {
                        return html.join('</p>');
                    }
                }

                return null;
            },

            rentalRegistration() {
                if (
                    (this.property) &&
                    (this.property.rentalRegistrationNumber)
                ) {
                    if (
                        (this.property.rentalRegistrationExpire) &&
                        (this.property.rentalRegistrationExpire.time < Date.now())
                    ) {
                        return null;
                    }

                    let re = 'Rental Registration: '+this.property.rentalRegistrationNumber;
                    if (this.property.rentalRegistrationExpire) {
                        re += ' expires on '+this.property.rentalRegistrationExpire.format('n/j/Y');
                    }

                    return re;
                }
                
                return null;
            },
            
        },

        methods: {
            setHasMoreDescription(val) {
                this.hasMoreDescription = val;
            },

            openFullDescription() {
                this.descriptionModalOpen = true;
                this.showDescriptionModal = true;
            },

            closeFullDescription() {
                this.showDescriptionModal = false;
                this.descriptionModalOpen = true;
            },
        }
    };

</script>
